import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX, ActionOverRecordTypes, IActionsSchema, triggerAction, ZendraLocalizationServices } from '@zendra/shared';
import { InterventionTypeService, PropertyService } from 'cbd-proxies';
import { RotationProjectionPlanningOrchestratorService } from 'orchestrator';
import { InterventionSoil } from '../intervention-soil/intervention-soil';

FieldBuilder.setNamespace('Geographic');

export const INTERVENTION_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .number('interventionId', 'Entity.Intervention.InterventionId')
    .readOnly()
    .build(),
  FieldBuilder
    .number('standId', 'Entity.Intervention.StandId')
    .readOnly()
    .build(),
  FieldBuilder
    .text('standName', 'Entity.Intervention.StandName')
    .readOnly()
    .build(),
  FieldBuilder.foreignKey('propertyId', 'Entity.Intervention.PropertyName', PropertyService)
    .display('name')
    .displayFromNested('propertyName')
    .sortBy('propertyName')
    .prefilter({ multiple: true })
    .readOnly()
    .build(),
  FieldBuilder
    .number('costReceiverId', 'Entity.Intervention.CostReceiverId')
    .readOnly()
    .build(),
  FieldBuilder
    .text('costReceiverName', 'Entity.Intervention.CostReceiverName')
    .readOnly()
    .build(),
  FieldBuilder
    .date('interventionDate', 'Entity.Intervention.InterventionDate')
    .required()
    .build(),
  FieldBuilder
    .number('workedArea', 'Entity.Intervention.WorkedArea')
    .decimal()
    .build(),
  FieldBuilder
    .checkbox('isInterventionCompleted', 'Entity.Intervention.IsInterventionCompleted')
    .readOnly()
    .hideInChildForms()
    .build(),
  FieldBuilder
    .checkbox('automaticallyProcessed', 'Entity.Intervention.AutomaticallyProcessed')
    .build(),
  FieldBuilder
    .number('standingArea', 'Entity.Intervention.StandingArea')
    .decimal()
    .build(),
  FieldBuilder.foreignKey(
    'rotationId',
    'Entity.StandCycleRotation.Rotation',
    RotationProjectionPlanningOrchestratorService
  )
    .required()
    .display('rotationDisplay')
    .displayFromNested('rotationNumber')
    .sortBy('rotationNumber')
    .build(),
  FieldBuilder.foreignKey(
    'interventionTypeId',
    'Entity.InterventionType',
    InterventionTypeService
  )
    .required()
    .display('name')
    .displayFromNested('interventionTypeName')
    .sortBy('interventionTypeName')
    .keyField('id')
    .build(),
];

const namespace = ZendraLocalizationServices.Geographic;

export const INTERVENTION_ACTION_IDS = {
  processInterventionTrigger: 0,
  unprocessInterventionTrigger: 1,
};

export const INTERVENTION_ACTIONS_CONFIG: IActionsSchema = {
  multipleRecord: [
    triggerAction(
      INTERVENTION_ACTION_IDS.processInterventionTrigger,
      'Action.Trigger.ProcessIntervention',
      ActionOverRecordTypes.MultipleRecord,
      namespace,
    ),
  ],
  singleRecord: [
    triggerAction(
      INTERVENTION_ACTION_IDS.unprocessInterventionTrigger,
      'Action.Trigger.UndoProcessIntervention',
      ActionOverRecordTypes.SingleRecord,
      namespace,
    ),
  ],
};

export const INTERVENTION_CONFIG = {
  entityName: 'Intervention',
  localizationKey: 'Geographic::Entity.Intervention',
  fields: INTERVENTION_FIELDS,
  permission: 'PlanningGeography.Interventions',
  actions: INTERVENTION_ACTIONS_CONFIG,
  actionIds: INTERVENTION_ACTION_IDS,
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Planning + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.TransactionsPlanning + MENU_NAME_SUFFIX,
  children: [
    {
      entityName: 'InterventionSoil',
      foreignKeyField: 'interventionId',
      localizationKey: 'Geographic::Entity.InterventionSoil',
      component: InterventionSoil,
    },
  ]
};
